import type { SVGProps } from 'react';
const DawnFlagSA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-SA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-SA_svg__a)">
      <path fill="#128C4B" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5.238 9.6h8.381v-.513c0-.497.526-.82.97-.594l.078.04V9.6h1.428c.369 0 .667.298.667.667v.133c0 .736-.597 1.333-1.333 1.333h-1.143a.667.667 0 0 1-.667-.666v-.4H6.566a.67.67 0 0 1-.476-.2zM5.238 6.536c0-.087.035-.171.096-.233l.199-.203a.333.333 0 0 0 0-.467l-.2-.202a.33.33 0 0 1-.095-.234V4.6c0-.184.15-.333.334-.333h.513c.11 0 .2.09.2.2 0 .214.289.28.382.09l.076-.156a.24.24 0 0 1 .217-.134h1.154a.267.267 0 1 1 0 .533H7.6a.267.267 0 1 0 0 .533h.448c.184 0 .333.15.333.334v1.466c0 .184-.15.334-.333.334h-.381a.333.333 0 0 1-.333-.334v-.471c0-.145.117-.262.261-.262s.262-.12.262-.264c0-.148-.12-.27-.266-.27h-.448a.333.333 0 0 0-.333.334v1.005a.262.262 0 0 1-.524 0v-.543a.262.262 0 1 0-.524 0v.543a.262.262 0 0 1-.524 0zM13.62 6.536c0-.087.033-.171.095-.233l.199-.203a.333.333 0 0 0 0-.467l-.2-.202a.33.33 0 0 1-.095-.234V4.6c0-.184.15-.333.334-.333h.513c.11 0 .2.09.2.2 0 .214.288.28.382.09l.076-.156a.24.24 0 0 1 .217-.134h1.154a.267.267 0 1 1 0 .533h-.514a.267.267 0 0 0 0 .533h.448c.184 0 .333.15.333.334v1.466c0 .184-.15.334-.333.334h-.381a.333.333 0 0 1-.334-.334v-.471c0-.145.118-.262.262-.262s.262-.12.262-.264c0-.148-.12-.27-.266-.27h-.448a.333.333 0 0 0-.333.334v1.005a.262.262 0 1 1-.524 0v-.543a.262.262 0 1 0-.524 0v.543a.262.262 0 0 1-.524 0zM12.572 5.064a.75.75 0 0 1-.19.462l-.145.148a.273.273 0 0 0 0 .385l.146.148c.104.107.189.307.189.462v.528c0 .15-.112.27-.265.27h-.519a.263.263 0 0 1-.264-.27V6.67c0-.149-.048-.17-.121-.022l-.281.572a.48.48 0 0 1-.381.248H9.688a.266.266 0 0 1-.26-.267c0-.147.113-.267.265-.267h.519a.27.27 0 0 0 .264-.266.26.26 0 0 0-.264-.267h-.519a.26.26 0 0 1-.264-.262v-1.61a.26.26 0 0 1 .264-.261h.519c.146 0 .264.114.264.269v.528c0 .149-.121.27-.262.27a.267.267 0 0 0-.261.266c0 .147.112.267.264.267h.519A.27.27 0 0 0 11 5.602V4.531a.262.262 0 1 1 .524.005v.528c0 .149.121.27.262.27a.26.26 0 0 0 .262-.27v-.528c0-.149.121-.27.262-.27.144 0 .262.115.262.27z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagSA;
